import { createContext, useContext } from 'react';
import { useAiEditor } from './hooks/use-ai-editor';

type UseAiEditorReturn = ReturnType<typeof useAiEditor>;

const AiEditorContext = createContext<UseAiEditorReturn | null>(null);

export const AiEditorProvider = AiEditorContext.Provider;

export const useAiEditorContext = (): UseAiEditorReturn => {
  const ctx = useContext(AiEditorContext);

  if (!ctx) {
    throw new Error('useAiEditorContext должен быть внутри AiEditorProvider');
  }

  return ctx;
};
